"use client";

import "./globals.css";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="cs">
      <body className="paper-bg">
        <main className="flex min-h-screen items-center justify-center px-5 py-16">
          <div className="sketch-panel max-w-lg p-8 text-center">
            <p className="font-marker text-6xl leading-none">Konec hry</p>
            <h1 className="mt-2 font-marker text-3xl">Celá stránka se zřítila</h1>
            <p className="mt-2 text-ink-soft">
              Obnovte stránku. Věž ani ovladače se tím nemažou, jen se překreslí papír.
            </p>
            {error.digest ? (
              <p className="mt-2 text-xs uppercase tracking-widest text-ink-faint">
                kód poruchy: {error.digest}
              </p>
            ) : null}
            <button
              type="button"
              onClick={reset}
              className="sketch-button sketch-button-primary mt-6"
            >
              Obnovit
            </button>
          </div>
        </main>
      </body>
    </html>
  );
}
